import { createUserWalletInvoice, fetchUserWalletInvoice } from '../../api/payments';
import {
  reportAttemptToCreateInvoice,
  reportInvoiceCreated,
  reportInvoiceCreationFailed,
  reportInvoiceFetched,
  reportInvoiceFetchFailed
} from '../../utils/reporter';

export const invoices = {
  effects: {
    async createWalletInvoice(createUserInvoiceRequest) {
      try {
        reportAttemptToCreateInvoice();
        const invoice = await createUserWalletInvoice(createUserInvoiceRequest);
        reportInvoiceCreated();
        return invoice;
      } catch (err) {
        reportInvoiceCreationFailed(err);
        throw err;
      }
    },
    async fetchUserWalletInvoice(invoiceId) {
      try {
        const invoice = await fetchUserWalletInvoice(invoiceId);
        reportInvoiceFetched();
        return invoice;
      } catch (err) {
        reportInvoiceFetchFailed(err);
        throw err;
      }
    }
  },
  reducers: null,
  state: null
};
